import * as React from 'react';
import { ResizeObserverPolyfill } from '../../../../util/polyfills.js';
import '../../../../util/styles/index.js';
import { useAdsStyles } from '../../../../util/styles/hooks/useAdsStyles.js';

var useTypographySizeContainer = function useTypographySizeContainer(props) {
  var variant = props.variant,
    setContentSize = props.setContentSize;
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles;
  var textContainerRef = React.useRef(null);
  React.useLayoutEffect(function () {
    var textContainer = textContainerRef.current;
    if (!textContainer) {
      return function () {};
    }
    var updateSize = function updateSize() {
      var _textContainer$getBou = textContainer.getBoundingClientRect(),
        height = _textContainer$getBou.height;
      setContentSize("".concat(height, "px"));
    };
    var cleanUp = function cleanUp() {};
    try {
      var observer = new ResizeObserverPolyfill(updateSize);
      observer.observe(textContainer);
      cleanUp = function cleanUp() {
        return observer.disconnect();
      };
    } catch (_unused) {
      // Resize observer is not supported in some tests unless mocked.
      // We gracefully handle it here to not mock observer in all the tests
    }
    updateSize();
    return cleanUp;
  }, [setContentSize]);
  var containerStyle = mapAdsStyles({
    display: 'inline-flex',
    alignItems: 'start'
  });
  var textContainerStyle = mapAdsStyles({
    display: 'inline-flex',
    width: 0,
    overflow: 'clip',
    visibility: 'hidden'
  });
  var typographyProps = {
    tag: 'span',
    variant: variant
  };
  return {
    containerStyle: containerStyle,
    textContainerStyle: textContainerStyle,
    textContainerRef: textContainerRef,
    typographyProps: typographyProps
  };
};

export { useTypographySizeContainer };
//# sourceMappingURL=useTypographySizeContainer.js.map
